import {useSelector} from '../../../store.js'
import {
  updateLabelConfig,
  labelConfigSelector,
  isLabelPropertyEnabledSelector,
} from '../../../data/labelInfos/index.js'
import {showEditAddressModal} from '../../Modals/EditAddressModal/editAddressFunctions.js'
import ConfigCheckbox from './ConfigCheckbox.js'
import {
  FEDEX,
  FEDEX_360,
  PITNEY,
  PITNEY_MERCHANT,
  SHIPPO,
  UPS,
  USPS_SHIP,
} from '../../../common/constants/ShipperNames.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from './useLabelProperty.js'
import className from '../../../common/className.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'

const LABEL_PROPERTY_USE_ALTERNATE_RETURN_TO_ADDRESS =
  'use_alternate_return_to_address'
const LABEL_PROPERTY_ALTERNATE_RETURN_TO_ADDRESS = 'alternate_return_to_address'

function labelPropertiesFunc() {
  return [
    LABEL_PROPERTY_USE_ALTERNATE_RETURN_TO_ADDRESS,
    LABEL_PROPERTY_ALTERNATE_RETURN_TO_ADDRESS,
  ]
}
const VALID_SHIPPER_TYPES = [
  FEDEX,
  FEDEX_360,
  PITNEY,
  PITNEY_MERCHANT,
  SHIPPO,
  UPS,
  USPS_SHIP,
]

export default function AlternateReturnToAddress() {
  const {
    labelInfoID,
    shipperType,
    onChange,
    isLabelEnableMode,
    isSummary,
    isPickMode,
  } = useLabelConfigContext()
  const propertySpecs = AlternateReturnToAddress.propertySpecList[0]
  const [useAlternateLabelProperty, alternateAddressLabelProperty] =
    propertySpecs.labelPropertiesFunc(shipperType, labelInfoID)

  const {
    [useAlternateLabelProperty]: useAlternateAddress,
    [alternateAddressLabelProperty]: address,
  } = useSelector((state) => labelConfigSelector(state, {labelInfoID}))

  const isLabelPropertyEnabled = useSelector((state) =>
    isLabelPropertyEnabledSelector(state, {
      labelInfoID,
      labelProperty: useAlternateLabelProperty,
    }),
  )

  const disabled = isLabelEnableMode && !isLabelPropertyEnabled

  return (
    <>
      <ConfigCheckbox
        label={
          isSummary
            ? 'Alternate Return Address'
            : 'Use Alternate Return Address'
        }
        checked={useAlternateAddress}
        onChange={(checked) => {
          updateLabelConfig(labelInfoID, {
            [useAlternateLabelProperty]: checked,
          })

          onChange({justSaveLabelConfig: true})
        }}
        labelProperty={useAlternateLabelProperty}
        propertySpecs={propertySpecs}
      />
      {VALID_SHIPPER_TYPES.includes(shipperType) &&
        useAlternateAddress &&
        !isSummary &&
        !isPickMode && (
          <div
            className={className`list__item--shipping-options has-sub-value ${
              disabled && 'wrap--edit-preset-disabled'
            }`}
          >
            <div>
              <label
                className="label--bold lh-sm margin-bottom-3"
                htmlFor="return_to"
              >
                Return To
              </label>
              <div className="fs-n0 lh-sm margin-bottom-3">
                {address ? (
                  address.company || address.name
                ) : (
                  <em>No address specified</em>
                )}
              </div>
              <button
                id="return_to"
                className="btn btn--link margin-bottom-0 fs-n1 block"
                type="button"
                onClick={() =>
                  showEditAddressModal({
                    hasAddressShortcuts: true,
                    address,
                    toastMessage:
                      'Alternate Return To Address was successfully updated.',
                    onSave: async (address) => {
                      updateLabelConfig(labelInfoID, {
                        [alternateAddressLabelProperty]: address,
                      })

                      onChange()
                    },
                  })
                }
              >
                Edit
              </button>
            </div>
          </div>
        )}
    </>
  )
}

AlternateReturnToAddress.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
